import { render } from "./job-requisition-form.vue?vue&type=template&id=4b3c6b63&scoped=true"
import script from "./job-requisition-form.vue?vue&type=script&lang=js"
export * from "./job-requisition-form.vue?vue&type=script&lang=js"

import "./job-requisition-form.vue?vue&type=style&index=0&id=4b3c6b63&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3c6b63"]])

export default __exports__